import type { CollectionExhibitInfoPageModelState } from './types';

export const initStates: CollectionExhibitInfoPageModelState = {
  pageLoading: true,

  exhibit_ID: '',
  exhibit_Name: '',
  exhibit_Title: '',
  exhibit_Online: false,
  exhibit_IsAuth: true,
  exhibit_AuthErrorText: '',
  exhibit_BelongNode_ID: -1,
  exhibit_BelongNode_Name: '',
  exhibit_BelongNode_Title: '',
  exhibit_BelongNode_ActiveThemeId: '',
  exhibit_Cover: '',
  exhibit_ResourceInfo: null,
  policy_List: [],

  graphShow: true,

  side_ExhibitTitle: '',
  side_ExhibitIntroduction: '',
  side_ExhibitTags: [],
  side_AllVersions: [],
  side_Version: '',
  side_SettingUnfold: false,
  side_RawProperties: [],
  side_BaseProperties: [],
  inheritOptions: [],
  customOptions: [],

  collectionItemsSetting: {
    collection_sort_list: 'collection_sort_ascending',
    collection_item_title: 'collection_item_title_rtitle',
    collection_item_no_display: 'collection_item_no_display_show',
    collection_item_image_display: 'collection_item_image_display_show',
    collection_item_descr_display: 'collection_item_descr_display_show',
    collection_view: 'collection_view_list',
  },
  collectionItems_keywords: '',
  collectionItems: [],
  collectionItems_totalCount: 0,
  collectionItems_pageCurrent: 1,
  collectionItems_pageSize: 10,
  collectionItems_inited: false,
};
